export interface IOrderSubStatusInput {
    failReasons: string[];
    successReasons?: string[];
}
